import React, { FC } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';
import MembersIndexPage from '@buyside/components/presentation/MembersIndexPage/membersIndexPage';

import { usersUrl } from '@buyside/util/urlHelper';

const MembersIndexPageRoot: FC = () => {
  return (
    <ErrorBoundary pageName="members index">
      <Router basename={usersUrl()}>
        <MembersIndexPage />
      </Router>
    </ErrorBoundary>
  );
};

export default MembersIndexPageRoot;
